var module = angular.module('components');
module.component('caArticleSearchSingleSelect', {
    templateUrl: 'components/genericcomponents/articlesearchsingleselect.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        pageSize: '<',
        disabledBy: '<',
        onArticleSelected: '&',
        onArticleRemoved: '&'
    },
    controller: ['$q', '$scope', 'ProductsApiService', 'loadSpinnerService', 'ToasterService', controller]
});

function controller($q, $scope, ProductsApiService, loadSpinnerService, ToasterService) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.searchResultArticles = [];
    vm.selectedArticle = undefined;
    vm.currentPage = 1;

    vm.refreshArticles = refreshArticles;
    vm.selectArticle = selectArticle;
    vm.removeArticle = removeArticle;

    function onInit() {
        if (!vm.pageSize) {
            vm.pageSize = 20;
        }

        $scope.$on('clearArticleEvent', function(e) {
            vm.selectedArticle = undefined;
        });
    }

    function onChanges(changes) {
        if (changes.disabledBy &&
            changes.disabledBy.currentValue !== changes.disabledBy.previousValue &&
            changes.disabledBy.currentValue === true) {
            vm.selectedArticle = undefined;
        }
    }

    function onDestroy() {
    }

    // Refreshes the contents of the drop-down-list of selectable articles.
    function refreshArticles(filter) {
        var companyId = null;
        var showInactiveArticles = true;
        var request = {
            currentPage: vm.currentPage,
            filter: filter,
            pageSize: vm.pageSize,
            companyId: companyId,
            showInactiveArticles: showInactiveArticles
        };
        ProductsApiService.getProducts(request).then(function(response) {
            vm.searchResultArticles = [];

            for (var i = 0; i < response.data.results.length; i++) {
                var article = response.data.results[i];
                vm.searchResultArticles.push(article);
            }
        }, function(error) {
            ToasterService.showError(error.errors);
        });
    }

    function selectArticle() {
        vm.onArticleSelected({article: vm.selectedArticle});
    }

    function removeArticle() {
        vm.selectedArticle = undefined;
        vm.onArticleRemoved();
    }
}
